import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { X, KeyRound, Mail, Eye, EyeOff } from "lucide-react";

export default function ChangePasswordModal({ open, onClose }) {
  const { user, refreshContext } = useAuth();
  const [pwd, setPwd] = useState({ current_password: "", new_password: "", confirm: "" });
  const [mail, setMail] = useState({ current_password: "", new_email: "" });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const submitPwd = async (e) => {
    e.preventDefault();
    if (pwd.new_password !== pwd.confirm) return toast.error("La confirmación no coincide.");
    if (pwd.new_password.length < 6) return toast.error("La nueva contraseña debe tener al menos 6 caracteres.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: pwd.current_password, new_password: pwd.new_password });
      toast.success("Contraseña actualizada");
      setPwd({ current_password: "", new_password: "", confirm: "" });
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const submitMail = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-email", { current_password: mail.current_password, new_email: mail.new_email });
      toast.success("Correo actualizado");
      setMail({ current_password: "", new_email: "" });
      if (refreshContext) refreshContext();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-start justify-center bg-black/70 p-4 overflow-y-auto">
      <div data-testid="change-password-modal" className="bg-[#0a0a0a] border border-white/20 w-full max-w-md my-12">
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h3 className="font-display text-2xl">MI PERFIL</h3>
          <button type="button" onClick={onClose} data-testid="change-password-close"><X className="w-5 h-5 text-white/50" /></button>
        </div>

        <form onSubmit={submitMail} className="p-6 border-b border-white/10 space-y-3">
          <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#00f0ff]" /><p className="overline">Cambiar correo</p></div>
          <p className="text-xs text-white/40">Correo actual: <span className="text-white/70">{user?.email}</span></p>
          <div><label className="overline block mb-1.5">Nuevo correo</label>
            <input data-testid="profile-new-email" type="email" required value={mail.new_email} onChange={(e) => setMail({ ...mail, new_email: e.target.value })} className="inp" /></div>
          <div><label className="overline block mb-1.5">Contraseña actual</label>
            <input data-testid="profile-email-password" type="password" required value={mail.current_password} onChange={(e) => setMail({ ...mail, current_password: e.target.value })} className="inp" /></div>
          <button type="submit" disabled={busy} data-testid="profile-email-submit" className="bg-[#00f0ff] text-black font-bold uppercase text-sm px-5 py-2 hover:bg-[#00c2cc] disabled:opacity-50">Actualizar correo</button>
        </form>

        <form onSubmit={submitPwd} className="p-6 space-y-3">
          <div className="flex items-center gap-2"><KeyRound className="w-4 h-4 text-[#00f0ff]" /><p className="overline">Cambiar contraseña</p></div>
          {[["current_password", "Contraseña actual"], ["new_password", "Nueva contraseña"], ["confirm", "Confirmar nueva contraseña"]].map(([k, label]) => (
            <div key={k}>
              <label className="overline block mb-1.5">{label}</label>
              <div className="relative">
                <input data-testid={`change-password-${k}`} type={show ? "text" : "password"} required value={pwd[k]} onChange={(e) => setPwd({ ...pwd, [k]: e.target.value })} className="inp pr-10" />
                {k === "current_password" && (
                  <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-[#00f0ff]">{show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
                )}
              </div>
            </div>
          ))}
          <button type="submit" disabled={busy} data-testid="change-password-submit" className="bg-[#00f0ff] text-black font-bold uppercase text-sm px-6 py-2.5 hover:bg-[#00c2cc] disabled:opacity-50">{busy ? "..." : "Actualizar contraseña"}</button>
        </form>
      </div>
    </div>
  );
}
